import React from "react";
import { Link } from "react-router-dom";
import styles from "../../../styles/styles";

const Hero = () => {
  return (
    <div
      className={`relative min-h-[70vh] 800px:min-h-[80vh] w-full bg-no-repeat ${styles.noramlFlex}`}
      style={{
        backgroundImage:
          "url(https://themes.rslahmed.dev/rafcart/assets/images/banner-2.jpg)",
      }}
    >
      <div className={`${styles.section} w-[90%] 800px:w-[60%]`}>
        <h1
          className={`text-[35px] leading-[1.2] 800px:text-[60px] text-[#3d3a3a] font-[600] capitalize`}
        >
          Best Collection for <br /> home Decoration
        </h1>
        <p className="pt-5 text-[16px] font-[Poppins] font-[400] text-[#000000ba]">
          Beautify Your Home with Jixify Home Décor Items The literal meaning
          of home is a place where you live, a place where you belong, a place
          that provides you comfort and care.<br /> The comfort and the sense of security
          that a home brings to you is immense. After a tiring day, you only
          want to crash on your living room sofa and talk your heart out to your
          loved ones.<br />{" "}
          A home is what you make of it. Since your
          home is your personal space, it should have your touch and reflect who
          you are. Decorating your home with home décor items is a great way to
          add a personal touch and make your home aesthetically appealing.
        </p>
        <Link to="/products" className="inline-block">
          <div className={`${styles.button} mt-5`}>
            <span className="text-[#fff] font-[Poppins] text-[18px]">
              Shop Now
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Hero;
